import tailwindConfig from '@/../tailwind.config';
// eslint-disable-next-line import/no-extraneous-dependencies
import resolveConfig from 'tailwindcss/resolveConfig';

// eslint-disable-next-line import/prefer-default-export
export const tailwind = resolveConfig(tailwindConfig);
